import gql from 'graphql-tag';

export const ALL_FUNDS_QUERY = gql`
  {
    allMutualFunds {
      broadAssetClass
      iClass
      morningStarRatings {
        asOfDate
        morningStarCategoryName
        morningStarOverallRating
        morningStarOverallQuantity
      }
      openToNewInvestors
      redemptionFee
      riskLevel
      taxFree
      ticker
      cusip
      name: shortName
      trpCode
      grossExpenseRatio
      netAssets
      netAssetsAsOfDate
      assetAllocationGroupedRankings {
        rank
        name
        percentTotalNetAssets
        asOfDate
      }
      mutualFundManagers {
        managerName
        managedFundSinceDate
        joinedFirmDate
      }
      standardPerformanceReturns {
        quarterlyAnnualReturns {
          fundPerformance {
            asOfDate
            oneYearReturn
            fiveYearReturn
            tenYearReturn
            sinceInceptionReturn
            sinceInceptionReturnTacked
          }
        }
      }
      price {
        asOfDate
        price
        priceChange
      }
      twelveMonthLowPrice {
        price
      }
      twelveMonthHighPrice {
        price
      }
      fundDescription
    }
  }
`;

export const sortedMockFunds = [
  {
    name: 'Retirement 2060 Fund',
    shortName: 'Retirement 2060',
    inceptionDate: 1403496000000,
    cusip: '74149P325',
    ticker: 'TRRLX',
    recordKeepingCode: '144',
    trpCode: 'RPN',
    price: {
      asOfDate: 1583384400000,
      price: 11.94,
      priceChange: -0.32,
      pricePercentChange: -2.61
    },
    twelveMonthLowPrice: {
      price: 12.12
    },
    twelveMonthHighPrice: {
      price: 12.12
    },
    stockExchange: null,
    stockSymbolCode: null,
    expenseRatioAsOfDate: null,
    iClass: false,
    rClass: false,
    advisorClass: false,
    assetClassName: 'Blended Asset',
    assetClassID: 500,
    assetClassParentID: 0,
    trpFund: true,
    moneyMarket: false,
    openToNewInvestors: true,
    openToSubsequentInvestments: true,
    bond: false,
    variableAnnuity: false,
    variableAnnuityTrust: false,
    readPrice: true,
    moneyMarketType: null,
    expenseRatio: 0.72,
    fundDescription: 'merp',
    taxFree: false,
    minimumInvestmentAmount: 2500,
    specificState: null,
    availableStates: [
      'AA',
      'AE',
      'AK',
      'AL',
      'AP',
      'AR',
      'AS',
      'AZ',
      'CA',
      'CO',
      'CT',
      'DC',
      'DE',
      'FL',
      'FM',
      'GA',
      'GU'
    ],
    redemptionFee: 0,
    objective:
      'The objective is to provide the highest total return over time consistent with an emphasis on both capital growth and income.',
    state: null,
    targetYear: 2060,
    spectrum: false,
    summit: false,
    retirement: true,
    subAssetCategoryID: 0,
    subAssetClassName: null,
    managementFee: 57,
    fee121b: 57,
    accountMaintenanceFee: 0,
    redemptionFeePeriod: 'N/A',
    mortalityExpense: 0,
    fiscalQuarterEndExpenseRatio: 0.72,
    fiscalQuarterEndDate: 1575090000000,
    institutional: false,
    advisory: false,
    fiscalYearEnd: null,
    fiscalYearEndMonth: null,
    wsjAbbreviation: null,
    strategyText: null,
    riskRewardText: null,
    fundRiskReward: { riskLevelText: 'Moderate', riskLevel: 260 },
    investorProfileText: null,
    monthlyComponentsAsOfDate: null,
    transactionFee: false,
    shortTermTradingFee: 0,
    shortTermTradingFeePeriod: null,
    frontEndLoad: 0,
    backEndLoad: 0,
    loadHistoryText: null,
    accountMinimumAddToAccount: 100,
    accountMinimumOpenIRA: 1000,
    accountMinimumAddToIRA: 100,
    accountMinimumSystematicPurchase: 0,
    grossExpenseRatio: 0.72,
    netExpenseRatio: 0.72,
    expenseRatioWaiverType: null,
    expenseRatioWaiverExpirationDate: null,
    morningStarRatings: {
      asOfDate: 1569816000000,
      morningStarCategoryName: 'Target-Date 2060+',
      morningStarOverallRating: 5,
      morningStarOverallQuantity: 0
    },
    moneyMarketReformMessages: null,
    fundExpense: 0,
    assetBasedFee: 0,
    portfolioInfoAsOfDate: null,
    retirementDateFund: true,
    targetDateFund: false,
    assetAllocationGroupedRankings: [
      {
        rank: 0,
        name: 'Foreign Bonds',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Preferred Stock',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Convertibles',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      },
      {
        rank: 0,
        name: 'Cash',
        percentTotalNetAssets: 25,
        asOfDate: '2020-01-31T05:00:00Z',
        __typename: 'Ranking'
      }
    ],
    allocation: {
      stocks: 88,
      bonds: 10,
      shortTermReserves: 3,
      asOfDate: 1580446800000
    },
    selectiveDisclosures: {
      monthly: [
        {
          asOfDate: '2025-07-31T04:00:00Z',
          top10CalculatedPercentage: 43.463769,
          individualHoldings: [
            {
              rank: 1,
              name: 'Al Rajhi Bank',
              percentTotalNetAssets: 10.359491,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 2,
              name: 'Saudi National Bank',
              percentTotalNetAssets: 6.243977,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 3,
              name: 'Naspers',
              percentTotalNetAssets: 5.469409,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 4,
              name: 'Qatar National Bank',
              percentTotalNetAssets: 4.098045,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 5,
              name: 'National Bank of Kuwait',
              percentTotalNetAssets: 3.595754,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 6,
              name: 'Saudi Arabian Oil',
              percentTotalNetAssets: 3.347699,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 7,
              name: 'FirstRand',
              percentTotalNetAssets: 2.924353,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 8,
              name: 'Capitec Bank Holdings',
              percentTotalNetAssets: 2.827689,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 9,
              name: 'Emaar Properties',
              percentTotalNetAssets: 2.339126,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            },
            {
              rank: 10,
              name: 'Anglogold Ashanti',
              percentTotalNetAssets: 2.258226,
              issuerGuarantorTypeName: 'Issuer',
              __typename: 'IndividualHolding'
            }
          ]
        }
      ],
      __typename: 'SelectiveDisclosures'
    },
    __typename: 'GraphQLMutualFund'
  }
];
